import { ClientFormPage } from "~/pages/ClientFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/clients/edit/$id")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const client = await queryClient.fetchQuery(trpc.clients.getClientById.queryOptions({ id: params.id }));
    return { client };
  },
});

function RouteComponent() {
  const { client } = Route.useLoaderData();
  useBreadCrumbs([
    { title: "Clients", link: `/${location.pathname.split("/")[1]}/data/clients` },
    { title: "Edit", link: `/${location.pathname.split("/")[1]}/data/clients/edit/${client.id}` },
  ]);
  return <ClientFormPage client={client} />;
}
